import price1 from "../../../assets/images/resource/price1.jpg"
import price2 from "../../../assets/images/resource/price2.jpg"
import price3 from "../../../assets/images/resource/price3.jpg"
import price4 from "../../../assets/images/resource/price4.jpg"
import price5 from "../../../assets/images/resource/price5.jpeg"
import price6 from "../../../assets/images/resource/price6.jpg"
import price7 from "../../../assets/images/resource/price7.jpg"
import price8 from "../../../assets/images/resource/price8.jpeg"
import price9 from "../../../assets/images/resource/price9.jpg"
import price10 from "../../../assets/images/resource/price10.jpg"
import price11 from "../../../assets/images/resource/price11.jpeg"
import price12 from "../../../assets/images/resource/price12.jpg"
import price13 from "../../../assets/images/resource/price13.jpg"
import price14 from "../../../assets/images/resource/price14.jpg"
import price15 from "../../../assets/images/resource/price15.jpeg"
import price16 from "../../../assets/images/resource/price16.jpg"
import price17 from "../../../assets/images/resource/price17.png"
import price18 from "../../../assets/images/resource/price18.jpg"
import price19 from "../../../assets/images/resource/price19.jpg"
import price20 from "../../../assets/images/resource/price20.jpg"
import price21 from "../../../assets/images/resource/price21.png"
import price22 from "../../../assets/images/resource/price22.jpg"
import price23 from "../../../assets/images/resource/price23.jpg"
import price24 from "../../../assets/images/resource/price24.jpg"
import price25 from "../../../assets/images/resource/price25.jpeg"
import price26 from "../../../assets/images/resource/price26.jpg"
import price27 from "../../../assets/images/resource/price27.jpg"
import price28 from "../../../assets/images/resource/price28.jpg"
import price29 from "../../../assets/images/resource/price29.png"
import price30 from "../../../assets/images/resource/price30.jpg"
import price31 from "../../../assets/images/resource/price31.jpg"
import price32 from "../../../assets/images/resource/price32.jpg"
import price33 from "../../../assets/images/resource/price33.jpg"
import price34 from "../../../assets/images/resource/price34.png"
export const ExpertsJson = [
    {
        name: "Alexandra Kafka",
        details: "Founder and Mindfulness Coach",
        image: price1
    },
    {
        name: "Dr Maria Fotiadou",
        details: "Happiness Expert",
        image: price2
    },
    {
        name: "Marilena",
        details: "Corporate Wellness Coach",
        image: price3
    },
    {
        name: "Nasia",
        details: "Transformational Life Coach",
        image: price4
    },
    {
        name: "Emma",
        details: "Somatic coach",
        image: price5
    },
    {
        name: "Harriet",
        details: "Hatha Yoga",
        image: price6
    },
    {
        name: "Rachel",
        details: "Yoga & Meditation Teacher",
        image: price7
    },
    {
        name: "Naomi",
        details: "Stress and Performance Coach",
        image: price8
    },
    {
        name: "Leanne",
        details: "Yoga and Meditation Teacher",
        image: price9
    },
    {
        name: "Olivia",
        details: "Yoga Teacher",
        image: price10
    },
    {
        name: "Jenny",
        details: "Aromatherapist & Yoga Teacher",
        image: price11
    },
    {
        name: "Stella",
        details: "Olympic Athlete",
        image: price12
    },
    {
        name: "Aris",
        details: "Pilates Instructor",
        image: price13
    },
    {
        name: "Iris",
        details: "Choreographer",
        image: price14
    },
    {
        name: "Dorota",
        details: "Nutritionist",
        image: price15
    },
    {
        name: "Karolos",
        details: "Food Expert",
        image: price16
    },
    {
        name: "Konstantinos",
        details: "Chef - Vegan & Vegeterian",
        image: price17
    },
    {
        name: "Helen",
        details: "Executive & Life coach",
        image: price18
    },
    {
        name: "Morag",
        details: "D&I Specialist",
        image: price19
    },
    {
        name: "Aziza",
        details: "Actress",
        image: price20
    },
    {
        name: "Nicolas",
        details: "Mixologist",
        image: price21
    },
    // {
    //     name: "Tanya",
    //     details: "Yoga & Meditation Teacher",
    //     image: price22
    // },
    {
        name: "Dan",
        details: "Health & Performance coach",
        image: price23
    },
    {
        name: "Selen",
        details: "Nutrition and Lifestyle Coach",
        image: price24
    },
    {
        name: "Marjory",
        details: "Finance Wellbeing and Interim Finance Director",
        image: price25
    },
    {
        name: "Raf",
        details: "Elite Athlete and Feedback Coach",
        image: price26
    },
    {
        name: "Julia",
        details: "Yoga Teacher and Sales Specialist",
        image: price27
    },
    {
        name: "Martin",
        details: "Fitness Trainer",
        image: price28
    },
    {
        name: "Andy",
        details: "Mindfulness & Meditation Coach",
        image: price29
    },
    {
        name: "Moon",
        details: "Personal Trainer & Gym Instructor",
        image: price30
    },
    {
        name: "Maira",
        details: "Lifestyle & Nutrition Coach",
        image: price31
    },
    {
        name: "Steven",
        details: "HIIT Specialist & Bootcamp Coach",
        image: price32
    },
    {
        name: "Kristina",
        details: "Transformational Coach",
        image: price33
    },
    {
        name: "Dr Clara",
        details: "Neuroscientist & Mindfulness Expert",
        image: price34
    }

] 